<template>
    <div class="updates">
        <div class="updates__item updates__item--catalog">
            <div class="update__label">{{resource('catalogVersion')}}</div>
            <div class="update__value">{{catalogDate | date}}</div>
        </div>
        <div class="updates__item updates__item--customers">
            <div class="update__label">{{resource('clientsVersion')}}</div>
            <div class="update__value">{{customersDate | date}}</div>
        </div>
        <div class="updates__item updates__item--app">
            <div class="update__label">{{resource('appVersion')}}</div>
            <div class="update__value">{{appVersion}}</div>
        </div>
				<button v-if="updateExists" class="updates__item updates__item--update-button button button--primary" @click="refreshApp">{{resource('update')}}</button>
    </div>
</template>
<style lang="scss">
.updates {
  padding: $content;
  font-size: 12px;
  background: $sidemenu-block__bg;
  &__item + &__item {
    padding-top: $component;
    margin-top: $component;
	}
}
</style>
<script>
export default {
	name: 'update',
	created () {
		// add listener for serviceworker update()
		document.addEventListener(
			'swUpdated', this.showRefreshUI, { once: true }
		)
		// refresh page automaticly if serviceworker is changed and is refreshing
		navigator.serviceWorker.addEventListener(
			'controllerchange', () => {
				if (this.refreshing) return
				this.refreshing = true
				window.location.reload()
			}
		)
	},
	computed:{
		syncing(){
			return this.$store.getters.syncing
		}
	},
	watch:{
		syncing(newVal){
			if(!newVal){
				this.updateTimes()
			}
		}
	},
	mounted(){
		this.catalogDate = this.makeTime(window.localStorage.getItem('lastUpdateProducts'))
		this.customersDate = this.makeTime(window.localStorage.getItem('lastUpdateClients'))
		this.appVersion = window.appVersion
	},
	methods:{
		resource(item){
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		makeTime(input){
			var d = new Date(0) // The 0 there is the key, which sets the date to the epoch
			d.setUTCSeconds(input)
			return d
		},
		updateTimes(){
			this.catalogDate = this.makeTime(window.localStorage.getItem('lastUpdateProducts'))
			this.customersDate = this.makeTime(window.localStorage.getItem('lastUpdateClients'))
		},
		showRefreshUI (e) {
			this.registration = e.detail
			this.updateExists = true
		},
		refreshApp () {
			this.updateExists = false
			if (!this.registration || !this.registration.waiting) { return }
			this.registration.waiting.postMessage('skipWaiting')
		},
	},
	data(){
		return {
			catalogDate: '',
			customersDate: '',
			appVersion: '',
			res:{
				nl:{
					catalogVersion: 'Laatste import catalogus:',
					clientsVersion: 'Laatste import klanten:',
					appVersion: 'Versie app:',
					update: 'Nieuwe versie beschikbaar'
				},
				fr:{
					catalogVersion: 'Dernier catalogue d\'importation:',
					clientsVersion: 'Derniers clients importés:',
					appVersion: 'Version app:',
					update: 'Nouvelle version disponible'
				}
			},
			refreshing: false,
			registration: null,
			updateExists: process.env.NODE_ENV === 'development',
		}
	}
}
</script>
